"use client";

import type { ErrorInfo, ReactNode } from "react";
import { Component } from "react";

import { DefaultErrorFallback } from "./DefaultErrorFallback";

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<{ children: ReactNode; fallback?: ReactNode }, ErrorBoundaryState> {
  constructor(props: { children: ReactNode; fallback?: ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Rendering Component Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const providedFallback = this.props.fallback !== undefined;
      return providedFallback ? this.props.fallback : <DefaultErrorFallback />;
    }

    return this.props.children;
  }
}
